var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwoosh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288.11,
    height: 85.616,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 224",
    d: "M1.362 85.616a1.356 1.356 0 0 1-.91-.35 1.363 1.363 0 0 1-.1-1.924c.461-.513 11.584-12.689 37.1-22.551 23.427-9.054 63.935-17.689 123.871-7.4 42.9 7.36 76.048 2.782 98.531-13.611 22.134-16.139 25.516-38.379 25.548-38.6a1.364 1.364 0 0 1 1.54-1.159 1.363 1.363 0 0 1 1.16 1.538c-.133.953-3.528 23.539-26.584 40.385-23.1 16.879-56.968 21.635-100.656 14.138-59.2-10.16-99.146-1.7-122.232 7.185C13.648 72.883 2.492 85.051 2.382 85.173a1.36 1.36 0 0 1-1.02.443Z",
    fill: "#ded434"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwoosh);
export default __webpack_public_path__ + "static/media/swoosh.3a43de585005b26df0b3b8afaf61a8fc.svg";
export { ForwardRef as ReactComponent };